<template>
  <div class="metafield-edit-date">
    <p class="metafield__title">{{ field.label }}</p>

    <datepicker
      class="metafield-edit-date__calendar"
      :inline="true"
      :full-month-name="true"
      :value="form.date"
      @input="handleDate"
    ></datepicker>

    <div class="metafield-edit-date__time" v-if="!subFormData.onlyDate">
      <BaseInput 
        type="number"
        label="Hours"
        :value="form.hour"
        @input="handleHours"
        formatNum="00"
        :maxVal="(subFormData.format12h) ? 12 : 24"
        minVal="0"
      ></BaseInput>  
      <BaseInput 
        type="number"
        label="Minutes"
        :value="form.minute" 
        @input="handleMinutes"
        maxVal="59"
        minVal="0"
        formatNum="00"
      ></BaseInput>  
      <BaseSwitcher
        v-if="subFormData.format12h"
        :value="form.isAm"
        @input="handleAm"
        trueLabel="AM"
        falseLabel="PM"
      ></BaseSwitcher>
    </div>

    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  components: {
    Datepicker
  },
  props: {
    value: [ String, Number ],
    subFormData: Object,
    field: Object,
    hint: String
  },
  data () {
    return {
      form: {
        date: null,
        hour: null,
        minute: null,
        isAm: null
      },
      test: '',
      dateFormat: 'YYYY-MM-DD'
    }
  },

  computed: {
    formattedDate() {
      return moment(this.value)
    }
  },

  mounted () {
    this.setFormToEdit(this.value)
    
  },

  methods: {
    setFormToEdit(val) {
      let hoursFormat = (this.subFormData.format12h) ? 'h' : 'H'
      let _value = (val) ? moment(new Date(val)) : moment()

      this.form = {
        date: _value.format(this.dateFormat),
        hour: (this.subFormData.onlyDate) ? 0 : _value.format(hoursFormat),
        minute: (this.subFormData.onlyDate) ? 0 : _value.format('m'),
        isAm: val && this.subFormData.format12h && val.includes('am')
      }
    },
    getDateAsString() {
      let am = ''
      if (this.subFormData.format12h) {
        am = (this.form.isAm) ? 'am' : 'pm'
      }

      if (this.subFormData.onlyDate) {
        return `${this.form.date}`
      }

      return `${this.form.date} ${this.form.hour}:${this.form.minute} ${am}`
    },
    handleAm(val) {
      this.form.isAm = val
      this.emit()
    },
    handleDate(val) {
      this.form.date = moment(val).format(this.dateFormat),
      this.emit()
    },
    handleHours(val) {
      this.form.hour = val
      this.emit()
    },
    handleMinutes(val) {
      this.form.minute = val
      this.emit()
    },
    emit() {
      let _val = this.getDateAsString()
      this.$emit('input', `${_val}`)
    }
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/mixins.scss';
  @import './src/assets/styles/breakpoints.scss';

  .metafield-edit-date {
    display: block;

    .TypographyInputHint {
      margin-top: 13px;
    }

    &__calendar {
      margin-top: 17px;

      .vdp-datepicker__calendar {
        width: 100%;
        border: none;

        header {
          span:hover {
            @include media(hover) {
              background: none !important;
            }
          }
 
          .prev {
            &:after {
              border-right-color: $color-pale-sky;
            }
          }

          .next {
            &:after {
              border-left-color: $color-pale-sky;
            }
          }

          .day__month_btn.up {
            font-size: 15px;
          }
        } 

        .cell {
          position: relative;
          font-size: 14.6px;

          &:after {
            position: absolute;
            top: -1px;
            right: -1px;
            bottom: -1px;
            left: -1px;
            z-index: 4;
            border: solid $color-purple;
          }

          &.day-header {
            color: $color-pale-sky;
          }

          &:not(.blank):not(.disabled).day:hover,
          &:not(.blank):not(.disabled).month:hover,
          &:not(.blank):not(.disabled).year:hover {
            @include media(hover) {
              border-color: $color-border;

              &:after {
                content: '';
                border-width: 1px;
              }
            }
          }

          &.day {
            border: 1px solid $color-border;
            margin: -1px -1px 0px 0px;
          }

          &.selected {
            background-color: $color-purple;
            color: #fff;

            &:after {
              content: '';
              border-width: 3px;
            }

            &:hover {
              @include media(hover) {
                background-color: $color-purple;
              }
            }
          }
        }
      }
    }

    &__time {
      margin-top: 17px;
      display: flex;
      align-items: flex-end;

      > *:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditDate.vue